export const primary = "#98aa85";
export const primary_light = "#A2B58D";
export const primary_double_light = "#C6D1BA";
export const primary_dark = "";
export const button_orange = "#f48507";
